/* eslint-disable @typescript-eslint/no-explicit-any */
import * as adminActions from 'context/AdminContext/actions';
import * as adminFlags from 'context/AdminContext/statusFlags';
import { addNotification } from 'context/AppContext/actions';
import * as userApi from 'services/productionV1/users';
import { APIResponseProps } from 'types/global';
import { delay } from 'utils';

export async function getUsers(adminDispatch:Function, reqParams:{}) {
  adminDispatch(adminActions.setAdminState(adminFlags.GET_USERS));
  await delay(500);
  const { response, errorMessage }:APIResponseProps = await userApi.getUsers(reqParams);
  if (response) {
    adminDispatch(adminActions.setUsers(response.users));
    adminDispatch(adminActions.setAdminState(adminFlags.GET_USERS_SUCCESS));
  }
  if (errorMessage) {
    adminDispatch(adminActions.setAdminState(adminFlags.GET_USERS_ERROR));
  }
}

export async function getUser({ adminDispatch, appDispatch, userId }: {
  adminDispatch: Function,
  appDispatch: Function,
  userId: String,
}) {
  adminDispatch(adminActions.setAdminState(adminFlags.GET_USER));
  await delay(500); 
  const { response, errorMessage }:APIResponseProps = await userApi.getUser(userId);
  if (response) {
    adminDispatch(adminActions.setUser(response));
    adminDispatch(adminActions.setAdminState(adminFlags.GET_USER_SUCCESS));
  }
  if (errorMessage) {
    appDispatch(addNotification({
      label: errorMessage,
      type: 'error',
    }));
    adminDispatch(adminActions.setAdminState(adminFlags.GET_USER_ERROR));
  }
}

export async function updateUser({ adminDispatch, appDispatch, data, newUser, userId }: {
  adminDispatch: Function,
  appDispatch: Function,
  data: {},
  newUser: boolean,
  userId: string,
}) {
  adminDispatch(adminActions.setAdminState(adminFlags.UPDATE_USER));
  await delay(500);
  try {
    await userApi.putUser({
      userId,
      data,
    });
    appDispatch(addNotification({
      label: `User Was Succesfully ${newUser ? 'Added' : 'Updated'}`,
      type: 'success',
    }));
    adminDispatch(adminActions.setAdminState(adminFlags.UPDATE_USER_SUCCESS));
  } catch (error: any) {
    appDispatch(addNotification({
      label: `There Was an Error ${newUser ? 'Adding' : 'Updating'} User`,
      type: 'error',
    }));
    adminDispatch(adminActions.setAdminState(adminFlags.UPDATE_USER_ERROR));
  }
}

export async function deleteUser({ adminDispatch, newUser, userId }: {
  adminDispatch: Function,
  newUser: boolean,
  userId: string,
}) {
  adminDispatch(adminActions.setAdminState(adminFlags.UPDATE_USER));
  await delay(500);
  try {
    if(!newUser) {
      await userApi.deleteUser(userId);
      adminDispatch(adminActions.setAdminState(adminFlags.UPDATE_USER_SUCCESS));
    }
  } catch (error) {
    adminDispatch(adminActions.setAdminState(adminFlags.UPDATE_USER_ERROR));
  }
}